import { useState } from 'react';

type TaskStatus = 'waiting' | 'done';
type FilterType = 'all' | 'waiting' | 'done';

interface Task {
  id: number;
  label: string;
  status: TaskStatus;
  date: string;
  who: string;
  priority: 'high' | 'low';
  category: string;
}

const allTasks: Task[] = [
  { id: 1, label: 'Schváliť finálny dizajn hlavnej stránky', status: 'waiting', date: 'Dnes', who: 'Vy', priority: 'high', category: 'Dizajn' },
  { id: 2, label: 'Dodať produktové fotografie (min. 30 ks)', status: 'waiting', date: '25.3.2025', who: 'Vy', priority: 'high', category: 'Obsah' },
  { id: 3, label: 'Kontrola a korekcia textov na stránke', status: 'done', date: '20.3.2025', who: 'Marek S.', priority: 'low', category: 'Obsah' },
  { id: 4, label: 'Poslať logo vo formáte SVG a PNG', status: 'done', date: '18.3.2025', who: 'Vy', priority: 'low', category: 'Podklady' },
  { id: 5, label: 'Odsúhlasiť obsah hero sekcie', status: 'done', date: '15.3.2025', who: 'Vy', priority: 'low', category: 'Obsah' },
  { id: 6, label: 'Zaslať prístupové údaje k domény', status: 'done', date: '10.3.2025', who: 'Vy', priority: 'low', category: 'Technické' },
  { id: 7, label: 'Schváliť štruktúru navigácie', status: 'done', date: '8.3.2025', who: 'Vy', priority: 'low', category: 'Dizajn' },
];

export default function PortalUlohy() {
  const [filter, setFilter] = useState<FilterType>('all');

  const filtered = filter === 'all' ? allTasks : allTasks.filter((t) => t.status === filter);
  const waitingCount = allTasks.filter((t) => t.status === 'waiting').length;
  const doneCount = allTasks.filter((t) => t.status === 'done').length;

  return (
    <div className="p-6 flex flex-col h-full gap-5 overflow-hidden">
      {/* Stats row */}
      <div className="flex-shrink-0 grid grid-cols-3 gap-3">
        {[
          { label: 'Všetky úlohy', value: allTasks.length, color: 'text-white' },
          { label: 'Čakajú na vás', value: waitingCount, color: 'text-orange-400' },
          { label: 'Dokončené', value: doneCount, color: 'text-emerald-400' },
        ].map((s) => (
          <div key={s.label} className="bg-zinc-900 border border-zinc-800 rounded-xl p-4 text-center">
            <p className={`text-2xl font-black ${s.color}`}>{s.value}</p>
            <p className="text-zinc-500 text-xs mt-0.5">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Filter + list */}
      <div className="flex-1 bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden flex flex-col">
        <div className="flex items-center gap-2 px-5 py-3.5 border-b border-zinc-800 flex-shrink-0">
          {(['all', 'waiting', 'done'] as FilterType[]).map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-4 py-1.5 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap transition-all ${filter === f ? 'bg-orange-500/15 border border-orange-500/25 text-orange-400' : 'bg-zinc-800 border border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
            >
              {f === 'all' ? 'Všetky' : f === 'waiting' ? 'Čakajúce' : 'Hotové'}
            </button>
          ))}
          <span className="ml-auto text-zinc-600 text-xs">{filtered.length} úloh</span>
        </div>

        <div className="flex-1 overflow-y-auto divide-y divide-zinc-800/50">
          {filtered.map((t) => (
            <div key={t.id} className={`flex items-center gap-4 px-5 py-4 hover:bg-zinc-800/30 transition-all ${t.status === 'done' ? 'opacity-60' : ''}`}>
              <div className={`w-8 h-8 rounded-lg flex-shrink-0 flex items-center justify-center ${t.status === 'done' ? 'bg-emerald-500/10 border border-emerald-500/20' : 'bg-orange-500/10 border border-orange-500/20'}`}>
                <i className={`text-sm ${t.status === 'done' ? 'ri-check-line text-emerald-400' : 'ri-time-line text-orange-400'}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${t.status === 'done' ? 'text-zinc-500 line-through' : 'text-zinc-200'}`}>{t.label}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-zinc-600 text-xs">{t.who}</span>
                  <span className="text-zinc-700 text-xs">·</span>
                  <span className="bg-zinc-800 border border-zinc-700 text-zinc-400 text-[10px] px-1.5 py-0.5 rounded-md">{t.category}</span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <span className={`text-xs font-semibold block ${t.status === 'waiting' && t.date === 'Dnes' ? 'text-red-400' : t.status === 'waiting' ? 'text-orange-400' : 'text-zinc-600'}`}>{t.date}</span>
                {t.priority === 'high' && t.status === 'waiting' && (
                  <span className="mt-1 inline-block bg-red-500/10 border border-red-500/20 text-red-400 text-[9px] px-1.5 py-0.5 rounded-full font-semibold">Priorita</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
